function createShadow(...px) {
  return [
    `${px[0]}px ${px[1]}px ${px[2]}px rgba(243, 243, 243, ${px[3]})`,
    `${px[4]}px ${px[5]}px ${px[6]}px rgba(24, 24, 43, ${px[7]})`,
    `${px[8]}px ${px[9]}px ${px[10]}px rgba(0, 0, 0, ${px[11]})`,
  ].join(',');
}

let shadowKeyUmbraOpacity = 0.1;
let shadowKeyPenumbraOpacity = 0.06;
let shadowAmbientShadowOpacity = 0.04;
let n = 24;

const shadows = [
  'none',
  '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
  '0px 1px 2px -1px rgba(0, 0, 0, 0.10), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)',
  '0px 2px 4px -2px rgba(0, 0, 0, 0.10), 0px 4px 6px -1px rgba(0, 0, 0, 0.10)',
  '0px 4px 6px -4px rgba(0, 0, 0, 0.10), 0px 10px 15px -3px rgba(0, 0, 0, 0.10)',
  '0px 8px 10px -6px rgba(0, 0, 0, 0.10), 0px 20px 25px -5px rgba(0, 0, 0, 0.10)', //xl
  '0px 25px 50px -12px rgba(0, 0, 0, 0.25)',
];

const ln = n - shadows.length;

for (let i = 0; i <= ln; i++) {
  shadows.push(
    '0px 8px 10px -6px rgba(0, 0, 0, 0.10), 0px 20px 25px -5px rgba(0, 0, 0, 0.10)',
  );
}

// for (let i = 0; i <= n; i++) {
//   if (i === 0) {
//     shadows.push('none');
//   } else {
//     let j = (i - 1) / (n - 1);
//     shadows.push(
//       createShadow(
//         0,
//         Math.round(5 + j * 2),
//         Math.round(15 + j * 8),
//         +(0.45 - j * 0.1).toFixed(4),
//         0,
//         +(1 + j * 4).toFixed(4),
//         Math.round(6 - j * 5),
//         +(0.02 + j * 0.15).toFixed(4),
//         0,
//         +(2 + j * 0.25).toFixed(4),
//         +(16 + j * 8).toFixed(4),
//         +(0.02 + j * 0.15).toFixed(4),
//       ),
//     );
//   }
// }

export default shadows;
